<script>
import SectionCard from '../SectionCard.vue';

export default {
  name: 'LegalSection',
  components: { SectionCard },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <SectionCard section-id="legal" :title="$t('REAL_ESTATE.LEGAL.TITLE')">
    <template #action>
      <woot-button
        variant="clear"
        size="small"
        icon="edit"
        @click="$emit('edit')"
      >
        {{ $t('REAL_ESTATE.LEGAL.EDIT_BUTTON') }}
      </woot-button>
    </template>

    <div class="flex flex-wrap gap-2">
      <span
        v-if="project.tenure"
        class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300"
      >
        {{ project.tenure }}
      </span>
      <span
        v-if="project.buyer_restriction"
        class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-amber-100 dark:bg-amber-900/60 text-amber-700 dark:text-amber-300"
      >
        {{ project.buyer_restriction }}
      </span>
      <p v-if="!project.buyer_restriction" class="text-sm text-slate-400">
        {{ $t('REAL_ESTATE.LEGAL.NO_RESTRICTION') }}
      </p>
    </div>
  </SectionCard>
</template>
